import React from 'react';
import { observer } from 'mobx-react';

import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/InjectedStyledComponent.js';
import { ITranslationContextValue } from '../Translate/models/ITranslationContextValue.js';
import Translate, { TranslationContext } from '../Translate/Translate.js';

import { INoDataPlaceholderConfiguration, INoDataPlaceholderProps, INoDataPlaceholderState } from './models/index.js';
import Wrapper from './styledComponents/Wrapper.js';
import { NO_DATA_PLACEHOLDER_CATEGORY_KEY, NO_DATA_PLACEHOLDER_COMPONENT_KEY } from './NoDataPlaceholder.meta.js';

export class NoDataPlaceholder extends ComponentBase<
	INoDataPlaceholderProps,
	INoDataPlaceholderState,
	INoDataPlaceholderConfiguration
> {
	categoryKey = NO_DATA_PLACEHOLDER_CATEGORY_KEY;
	componentKey = NO_DATA_PLACEHOLDER_COMPONENT_KEY;

	constructor(props: INoDataPlaceholderProps) {
		super(props);
	}

	render() {
		const { className, children } = this.props;
		return (
			<Wrapper className={className}>
				<TranslationContext.Consumer>
					{(translationContext: ITranslationContextValue) => {
						return <Translate>{translationContext.translate(children)}</Translate>;
					}}
				</TranslationContext.Consumer>
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(
	observer(NoDataPlaceholder),
	NO_DATA_PLACEHOLDER_CATEGORY_KEY,
	NO_DATA_PLACEHOLDER_COMPONENT_KEY,
);
